// extracted by mini-css-extract-plugin
module.exports = {"titleIcon":"ViewChargeAffirm_titleIcon__1TxAI","inputPhoneContainer":"ViewChargeAffirm_inputPhoneContainer__3Hxj-"};